// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — options.styled.classic.js, новая — options.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './options.styled.classic';
import * as cp from './options.styled.cp';

export const ButtonPlace = isCp ? cp.ButtonPlace : classic.ButtonPlace;
export const Buttons = isCp ? cp.Buttons : classic.Buttons;
export const Content = isCp ? cp.Content : classic.Content;
export const Items = isCp ? cp.Items : classic.Items;
export const Left = isCp ? cp.Left : classic.Left;
export const Offline = isCp ? cp.Offline : undefined;
export const Reloader = isCp ? cp.Reloader : classic.Reloader;
export const Right = isCp ? cp.Right : classic.Right;
export const Title = isCp ? cp.Title : classic.Title;
export const Wrapper = isCp ? cp.Wrapper : classic.Wrapper;
